import React from "react";
import BreadCrumb from "common/breadcrumb";
import BasicButtons from "./basic-buttons";
import SoftDashed from "./soft-dashed";
import AnimationButton from "./animation-button";
import IconButtons from "./icon-buttons";
import SizesRounded from "./sizes-rounded";
import LabelIcon from "./label-icon";

const UiButtons = () => {
    return (
        <React.Fragment>
            <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
                <BreadCrumb title='Buttons' pageTitle='UI Elements' />
                <div>
                    <BasicButtons />
                    <SoftDashed />
                    <AnimationButton />
                    <IconButtons />
                    <SizesRounded />
                    <LabelIcon />
                </div>
            </div>
        </React.Fragment>
    );
}

export default UiButtons;